import React from 'react';
import {View} from 'react-native';
import FabBackButton from '../../../../../components/fab-back-button/FabBackButton.componet';
import {useHistory} from '../../../../../imports/Router';
import Step from '../step/Step.component';
import styles from './StepHeader.style';

export default function StepHeader(props) {
  const {numberOfPoints, activeIndex, cancelable} = props;
  const history = useHistory();

  return (
    <View
      style={[
        styles.container,
        {
          justifyContent: cancelable ? 'space-between' : 'flex-end',
        },
      ]}>
      {cancelable && (
        <FabBackButton
          icon="closeIcon"
          iconSize={16}
          container_style={styles.closeButton}
          onPress={() => {
            history.replace('/register/info');
          }}
        />
      )}
      <Step {...props} />
    </View>
  );
}
